module.exports = __webpack_public_path__ + "img/right-arrow.a6dfbed7.svg";